export default {
    en: {
        LANDING_LOGIN_ACTIVE_COMPETITION: 'Enter',
        LANDING_LOGIN_EXPIRED_COMPETITION: 'Login',
        LANDING_STARTS_IN: 'Starts in',
        LANDING_ENDS_IN: 'Ends in'
    }
};
